import * as PropTypes from 'prop-types';
import * as React from 'react';
import { createElement } from 'react';
import TouchFeedback from 'rmc-feedback';
import Input from './Input';
import clearImg from './images/icon_clear@3x.png';
import './styles/index.less';
import { getClassName, calcPos, normalizeValue } from './funtions';
import iIcon from './images/i-icon-@2x.png';
class InputItem extends React.Component {
    constructor(props) {
        super(props);
        this.onInputChange = (e) => {
            const el = e.target;
            const { value: rawVal } = el;
            const { maxLength, isReg, onChange } = this.props;
            let prePos = 0;
            if (isReg) {
                try {
                    prePos = el.selectionEnd || 0;
                }
                catch (error) {
                    console.warn('Get selection error:', error);
                }
                const { value: preCtrlVal = '' } = this.state;
                const { type } = this.props;
                let ctrlValue = rawVal;
                switch (type) {
                    case 'bankCard':
                        ctrlValue = rawVal
                            .replace(/\D/g, '')
                            .replace(/(....)(?=.)/g, '$1 ')
                            .substring(0, Math.max(ctrlValue.length < 20
                            ? Math.max(19, maxLength ? maxLength : 0 + 3)
                            : Math.max(23, maxLength ? maxLength : 0 + 4)));
                        break;
                    case 'phone':
                        ctrlValue = rawVal
                            .replace(/\D/g, '')
                            .substring(0, Math.max(11, maxLength ? maxLength : 0 + 3));
                        const valueLen = ctrlValue.length;
                        if (valueLen > 3 && valueLen < 8) {
                            ctrlValue = `${ctrlValue.substr(0, 3)} ${ctrlValue.substr(3)}`;
                        }
                        else if (valueLen >= 8) {
                            ctrlValue = `${ctrlValue.substr(0, 3)} ${ctrlValue.substr(3, 4)} ${ctrlValue.substr(7)}`;
                        }
                        break;
                    case 'number':
                        ctrlValue = rawVal.replace(/\D/g, '');
                        break;
                    case 'text':
                    default:
                        break;
                }
                this.handleOnChange(ctrlValue, ctrlValue !== rawVal, () => {
                    switch (type) {
                        case 'bankCard':
                        case 'phone':
                        case 'number':
                            try {
                                let pos = calcPos(prePos, preCtrlVal, rawVal, ctrlValue, [' '], /\D/g);
                                if ((type === 'phone' && (pos === 4 || pos === 9)) ||
                                    (type === 'bankCard' && pos > 0 && pos % 5 === 0)) {
                                    pos -= 1;
                                }
                                el.selectionStart = el.selectionEnd = pos;
                            }
                            catch (error) {
                                console.warn('Set selection error:', error);
                            }
                            break;
                        default:
                            break;
                    }
                });
                this.setState({
                    visitable: true,
                });
            }
            else {
                onChange?.(e.target.value);
            }
        };
        this.handleOnChange = (value, isMutated = false, adjustPos) => {
            const { onChange } = this.props;
            if (!('value' in this.props)) {
                this.setState({ value });
            }
            else {
                this.setState({ value: this.props.value });
            }
            if (onChange) {
                if (isMutated) {
                    setTimeout(() => {
                        onChange(value);
                        adjustPos();
                    });
                }
                else {
                    onChange(value);
                    adjustPos();
                }
            }
            else {
                adjustPos();
            }
        };
        this.onInputFocus = (value) => {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
            this.setState({
                focus: true,
                visitable: true,
                isBlur: false,
            });
            if (this.props.onFocus) {
                this.props.onFocus(value);
            }
        };
        this.onInputBlur = (value) => {
            if (this.inputRef) {
                this.debounceTimeout = window.setTimeout(() => {
                    if (document.activeElement !== this.inputRef?.inputRef) {
                        this.setState({
                            focus: false,
                            visitable: false,
                            isBlur: true,
                        });
                    }
                }, 200);
            }
            if (this.props.onBlur) {
                setTimeout(() => {
                    if (document.body) {
                        document.body.scrollTop = document.body.scrollTop;
                    }
                }, 100);
                this.props.onBlur(value);
            }
        };
        this.clearInput = () => {
            if (this.props.updatePlaceholder) {
                this.setState({
                    placeholder: this.props.value,
                });
            }
            this.setState({
                value: '',
            });
            if (this.props.onChange) {
                this.props.onChange('');
            }
            this.focus();
        };
        this.focus = () => {
            if (this.inputRef) {
                this.inputRef.focus();
            }
        };
        this.onSearchClick = (item, index) => {
            this.setState({
                value: item.keyword,
                visitable: false,
            });
            item.fnc?.();
            this.props.onSearchItemClick?.(item, index);
        };
        this.handleEnterPress = (e) => {
            this.props.onEnterPress?.(e);
        };
        this.state = {
            placeholder: props.placeholder,
            value: normalizeValue(props.value || props.defaultValue),
            visitable: false,
            isBlur: true,
        };
    }
    componentWillReceiveProps(nextProps) {
        if ('placeholder' in nextProps && !nextProps.updatePlaceholder) {
            this.setState({
                placeholder: nextProps.placeholder,
            });
        }
        if ('value' in nextProps) {
            this.setState({
                value: nextProps.value,
            });
        }
    }
    componentWillUnmount() {
        if (this.debounceTimeout) {
            window.clearTimeout(this.debounceTimeout);
            this.debounceTimeout = null;
        }
    }
    render() {
        const props = { ...this.props };
        delete props.updatePlaceholder;
        const { prefixCls, prefixListCls, editable, inputStyle, clear, children, error, className, extra, labelNumber, type, moneyKeyboardAlign, moneyKeyboardWrapProps, moneyKeyboardHeader, disabledKeys, titleWidth, title, desc, data, isTitleUp, leftTitleIcon, textStyle, textAlign, isSearch, hidebottomline, onErrorClick, onExtraClick, onSearchItemClick, showTitleIcon, titleIconSrc, titleIconFunc, inputAriaLabel, ...restProps } = props;
        const { name, disabled, maxLength } = restProps;
        const { value, isBlur } = this.state;
        const { placeholder } = this.state;
        const classNames = getClassName({
            disabled,
            error,
            labelNumber,
            hidebottomline,
            title,
            textAlign,
            desc,
            children,
            isTitleUp,
            isSearch,
            extra
        });
        const { wrapCls, labelCls, titleWrap, lineCls, controlCls, clearCls, errorCls } = classNames;
        let inputType = 'text';
        if (type === 'bankCard' || type === 'phone') {
            inputType = 'tel';
        }
        else if (type === 'digit') {
            inputType = 'number';
        }
        else if (type !== 'text' && type !== 'number') {
            inputType = type;
        }
        let patternProps;
        if (type === 'number') {
            patternProps = {
                pattern: '[0-9]*',
            };
        }
        let classNameProps;
        if (type === 'digit') {
            classNameProps = {
                className: 'h5numInput',
            };
        }
        const searchData = data?.filter(item => {
            if (item.keyword.indexOf(value) > -1) {
                return item;
            }
            return searchData;
        });
        return (createElement("div", { className: wrapCls },
            createElement("div", { className: lineCls },
                title ? (createElement("div", { className: `${prefixCls}-title-container ${titleWrap}` },
                    createElement("div", { className: `${prefixCls}-title-left` },
                        leftTitleIcon && (createElement("img", { src: leftTitleIcon, alt: "", "aria-hidden": "true" })),
                        createElement("div", { className: labelCls, style: {
                                width: isTitleUp ? '100%' : titleWidth,
                                paddingRight: showTitleIcon ? '0px' : '5px',
                                ...textStyle,
                            } },
                            title,
                            showTitleIcon && titleIconSrc && (createElement("img", { className: `${prefixCls}-container-left-titleIcon`, onClick: titleIconFunc, src: titleIconSrc, alt: "\u63D0\u793A" }))),
                        desc ? (createElement("div", { className: `${prefixCls}-label-desc`, style: {
                                maxWidth: showTitleIcon
                                    ? `${parseInt(titleWidth, 10) - 15}px`
                                    : titleWidth,
                                paddingRight: showTitleIcon ? '0px' : '3px',
                                ...textStyle,
                            } }, desc)) : null))) : null,
                children ? (createElement("div", { className: labelCls, style: { width: titleWidth } }, children)) : null,
                createElement("div", { style: {
                        display: 'flex',
                        position: 'relative',
                        flex: '1',
                        flexDirection: 'column',
                        width: isTitleUp ? '100%' : '',
                    } },
                    createElement("div", { className: controlCls, role: 'text', "aria-label": inputAriaLabel ? inputAriaLabel : placeholder, tabIndex: 1 },
                        type === 'money' ? null : (createElement(Input, Object.assign({}, patternProps, restProps, classNameProps, { value: normalizeValue(value), defaultValue: undefined, ref: (el) => (this.inputRef = el), style: inputStyle, type: inputType, maxLength: maxLength, name: name, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onEnterPress: this.handleEnterPress, readOnly: !editable, disabled: disabled, role: "group" }))),
                        clear &&
                            editable &&
                            !disabled &&
                            value &&
                            !isBlur &&
                            `${value}`.length > 0 ? (createElement(TouchFeedback, { activeClassName: `${prefixCls}-clear-active` },
                            createElement("div", { className: `${prefixCls}-clear-wrap` },
                                createElement("img", { className: clearCls, onClick: this.clearInput, src: clearImg, alt: "\u6E05\u9664", slot: "button" })))) : null,
                        extra !== '' ? (createElement("div", { className: `${prefixCls}-extra`, onClick: onExtraClick }, extra)) : null),
                    data && Boolean(value) && this.state.visitable ? (createElement("div", { className: `${prefixCls}-searchWrap` }, (isSearch ? searchData : data).map((item, index) => {
                        return (createElement("div", { key: item.id, className: `${prefixCls}-searchWrap-item`, onClick: () => this.onSearchClick(item, index) },
                            createElement("span", null, item.keyword)));
                    }))) : null,
                    error && !isTitleUp && !isSearch && (createElement("div", { className: `${prefixCls}-error`, onClick: onErrorClick },
                        createElement("span", null, error))))),
            error && (isTitleUp || isSearch) && (createElement("div", { className: errorCls, onClick: onErrorClick },
                createElement("span", null, error))),
            !hidebottomline && (createElement("div", { className: 'im-inputitem-item-bottomLine' }))));
    }
}
InputItem.defaultProps = {
    prefixCls: 'im-input',
    prefixListCls: 'im-inputitem',
    type: 'text',
    editable: true,
    disabled: false,
    placeholder: '',
    clear: false,
    extra: '',
    error: '',
    labelNumber: 7,
    updatePlaceholder: false,
    moneyKeyboardAlign: 'right',
    moneyKeyboardWrapProps: {},
    moneyKeyboardHeader: null,
    disabledKeys: null,
    hidebottomline: true,
    textAlign: 'left',
    isSearch: false,
    showTitleIcon: false,
    titleIconSrc: iIcon,
    isReg: true,
};
InputItem.contextTypes = {
    antLocale: PropTypes.object,
};
export default InputItem;
export { InputItemPropsType } from './PropsType';
